<template>
  <ui-dialog show max-width="542px" @input="$emit('close')">
    <template #header>
      <h3>{{ title }}</h3>
    </template>
    <div class="content">
      <div v-html="description"></div>
    </div>
    <template #actions>
      <ui-button color="primary" outlined @click="$emit('close')">
        {{ $t(cancelBtnText) }}
      </ui-button>
      <ui-button color="primary" @click="$emit('confirm')">
        {{ $t(confirmBtnText) }}
      </ui-button>
    </template>
  </ui-dialog>
</template>

<script>
export default {
  name: "FacebookAlertDialog",
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    cancelBtnText: {
      type: String,
      default: "message.common.cancel"
    },
    confirmBtnText: {
      type: String,
      default: "message.common.confirm"
    }
  }
};
</script>
